import React from 'react';
import { Section, TwoColumns } from 'src/components/Section';
import { SectionSubtitle, Paragraph } from 'src/components/Typography';
import { AnchorButton } from 'src/components/Button';
import sizes from 'src/style/sizes';
import { mediaQueries } from 'src/style/breakpoints';

const CTAFooter = () => {
  return (
    <Section theme="primary">
      <TwoColumns
        sizeLeft={sizes.columnWidth.large}
        left={
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              textAlign: 'center',
              [mediaQueries.tabletLandscapeUp]: {
                justifyContent: 'flex-start',
                textAlign: 'left',
              },
            }}
          >
            <SectionSubtitle>D'autres questions ?</SectionSubtitle>
            <Paragraph>
              Visionnez notre réunion d’information pour découvrir les formations,
              les programmes et les possibilités de financement.
            </Paragraph>
          </div>
        }
        sizeRight={sizes.columnWidth.medium}
        right={
          <div
            css={{
              display: 'flex',
              justifyContent: 'center',
              paddingTop: 0,
              [mediaQueries.tabletLandscapeUp]: {
                justifyContent: 'flex-end',
                paddingTop: 40,
                paddingLeft: 160,
              },
            }}
          >
            <AnchorButton to="/reunion-d-information/">Réunion d’information</AnchorButton>
          </div>
        }
      />
    </Section>
  );
};
export default CTAFooter;
